import React from 'react';
import { useNavigate } from 'react-router-dom';
import SectionHead from '../components/SectionHead';
import data from '../data/siteData.json';

function Products() {
  const navigate = useNavigate();

  const products = data.solutions.items.map((item, index) => ({
    id: `product-${index + 1}`,
    title: item.title,
    description: item.copy,
    features: item.bullets,
  }));

  const handleGetEnquiry = (product) => {
    navigate('/demo', { 
      state: { 
        product: {
          title: product.title,
          description: product.description,
        }
      } 
    });
  };

  return (
    <section className="section" id="products">
      <SectionHead
        title="Our Services"
        copy="Comprehensive AMC, repair, and maintenance services for all types of lifts and elevators."
      />
      <div className="grid cards products-grid">
        {products.map((product) => (
          <article className="card product-card" key={product.id}>
            <h3>{product.title}</h3>
            <p>{product.description}</p>
            <ul>
              {product.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
            <div className="product-actions">
              <button
                className="primary"
                onClick={() => handleGetEnquiry(product)}
              >
                Get Enquiry
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Products;
